import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subject, filter, takeUntil } from 'rxjs';
import { MessagingService } from './services/messaging.service';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { TopbarComponent } from './components/topbar/topbar.component';

// Routes that use the full-page layout (no shell)
const NO_SHELL_ROUTES = ['/dang-nhap', '/login', '/dang-ky', '/unauthorized'];

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SidebarComponent,
    TopbarComponent
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  showShell = false;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private messagingService: MessagingService
  ) {}

  ngOnInit(): void {
    this.updateShellVisibility(this.router.url);

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => {
      this.updateShellVisibility(e.urlAfterRedirects);
    });
  }

  private updateShellVisibility(url: string): void {
    this.showShell = !NO_SHELL_ROUTES.some(r => url.startsWith(r));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
